import { z } from 'zod/v3';
import {
  transformNullish,
  transformToValidPeriod,
  zIsoDate,
} from '../../../common/utils';
import { zAlgorithmType } from './zAlgorithmType';

const AlgorithmBaseFormDataSchema = z.object({
  id: transformNullish(z.number().readonly(), -1),
  typeCode: zAlgorithmType.optional(),
  dataObjectDescriptionVersionId: transformNullish(z.number().readonly(), -1),
  code: transformNullish(z.string(), ''),
  groupCode: transformNullish(z.string(), ''),
  sequenceNumber: z.number(),
  validFrom: zIsoDate().nullable(),
  validTo: zIsoDate().nullable(),
  statusId: transformNullish(z.number(), -1),
  statusName: transformNullish(z.string(), ''),
  description: transformNullish(z.string(), ''),
  execAfterAggregation: z.boolean().nullable(),
  filterClause: transformNullish(z.string(), ''),
});

const transform = <T extends typeof AlgorithmBaseFormDataSchema.shape>(
  schemaVariant: z.ZodObject<T>,
) =>
  transformToValidPeriod(schemaVariant) // Workaround for known issue: https://github.com/colinhacks/zod/issues/2732
    .transform(
      (data) => data as Omit<typeof data, 'id'> & { readonly id: number },
    );

export const AlgorithmFormDataSchema = z.union([
  transform(
    AlgorithmBaseFormDataSchema.extend({
      aggregatePeriods: z.boolean(),
      expression: transformNullish<''>(z.literal(''), ''),
    }),
  ),
  transform(
    AlgorithmBaseFormDataSchema.extend({
      aggregatePeriods: z.null(),
      expression: transformNullish<string>(z.string(), ''),
    }),
  ),
]);
